<template>
  <div>
    <el-form-item label="Environment">
      <el-select v-model="form.env" @change="change">
        <el-option value="development" label="Development" />
        <el-option value="staging" label="Staging" />
        <el-option value="production" label="Production" />
      </el-select>
    </el-form-item>

    <el-form-item label="Package manager">
      <el-select v-model="form.pkg" @change="change">
        <el-option value="bundle" label="Gemfile" />
      </el-select>
    </el-form-item>

    <el-form-item label="Entrypoint">
      <el-input
        v-model="form.entrypoint"
        placeholder="Default : index.rb"
        @input="change"
      />
    </el-form-item>
  </div>
</template>

<script>
import config from '../../../mixins/config'
export default {
  mixins: [config]
}
</script>
